import { toClientWorkflowStage } from "../lib/proposalContract";

export const ADMIN_STAGE_ORDER = [
  "in_review",
  "initial_consultation",
  "proposal_contract",
  "event_preparation",
  "event_live",
];

export const canonicalizeStatus = (value) => {
  const normalized = String(value || "").trim().toLowerCase().replace(/\s+/g, "_");
  if (normalized === "pending_review" || normalized === "new") return "in_review";
  const mapped = toClientWorkflowStage(normalized);
  if (["in_review", "initial_consultation", "proposal_contract", "event_preparation", "event_live", "declined"].includes(mapped)) {
    return mapped;
  }
  return "in_review";
};

const stageIndex = (status) => ADMIN_STAGE_ORDER.indexOf(canonicalizeStatus(status));

export const isCurrentStage = (status, stage) => canonicalizeStatus(status) === stage;

export const isDeclinedStatus = (status) => canonicalizeStatus(status) === "declined";

export const DECLINE_REASON_OTHER = "other";

export const DECLINE_REASON_OPTIONS = [
  { value: "date_unavailable", label: "Date unavailable" },
  { value: "venue_not_supported", label: "Venue not supported" },
  { value: "budget_out_of_range", label: "Budget out of range" },
  { value: "incomplete_requirements", label: "Incomplete requirements" },
  { value: "outside_service_scope", label: "Outside service scope" },
  { value: DECLINE_REASON_OTHER, label: "Other (custom)" },
];

export const resolveDeclineReason = (choice, customText = "") => {
  if (choice === DECLINE_REASON_OTHER) {
    return String(customText || "").trim();
  }
  const option = DECLINE_REASON_OPTIONS.find((item) => item.value === choice);
  return option?.label || "";
};

export const isAfterStage = (status, stage) => {
  const current = canonicalizeStatus(status);
  if (current === "declined") return true;
  const currentIndex = stageIndex(current);
  const targetIndex = stageIndex(stage);
  return currentIndex !== -1 && targetIndex !== -1 && currentIndex > targetIndex;
};

export const getStageFieldVisibility = (status) => {
  const currentStatus = canonicalizeStatus(status);
  const editClientEvent = isCurrentStage(currentStatus, "in_review") || isCurrentStage(currentStatus, "proposal_contract");
  const editConsultation = isCurrentStage(currentStatus, "initial_consultation");
  const editProposalContract = isCurrentStage(currentStatus, "proposal_contract");

  return {
    currentStatus,
    editClientEvent,
    showClientEventSummary: !editClientEvent,
    editConsultation,
    showConsultationSummary: isAfterStage(currentStatus, "initial_consultation"),
    editProposalContract,
    showProposalContractSummary: isAfterStage(currentStatus, "proposal_contract"),
    canEditStageFields: editClientEvent || editConsultation || editProposalContract,
  };
};
